import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsSurveyStepElementOptionsLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} surveyStepElementOption
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsSurveyStepElementOptionsLinkState */

/**
 * @extends {ShapeComponent<ComponentsSurveyStepElementOptionsLinkProps, ComponentsSurveyStepElementOptionsLinkState>}
 */
class ComponentsSurveyStepElementOptionsLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    surveyStepElementOption: instanceOfClassName("SurveyStepElementOption").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, surveyStepElementOption, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--survey-step-element-options--link", className)
    const to = this.to()

    if (to != "#") {
      return (
        <Link className={generatedClassName} to={this.to()} {...restProps}>
          {children || surveyStepElementOption.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || surveyStepElementOption.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, surveyStepElementOption} = this.p

    if (adminLayout) {
      return Routes.adminSurveyStepElementOptionPath(surveyStepElementOption.id())
    }

    return "#"
  }
}

export default memo(shapeComponent(ComponentsSurveyStepElementOptionsLink))
